var map = {
	"./en.json": [
		"0dfa",
		"chunk-2d0af6e5"
	],
	"./jp.json": [
		"e44f",
		"chunk-2d225457"
	],
	"./ko.json": [
		"a65e",
		"chunk-2d208a7b"
	],
	"./tw.json": [
		"8f52",
		"chunk-2d0e9b41"
	],
	"./vn.json": [
		"112a",
		"chunk-2d0aa585"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8ad0";
module.exports = webpackAsyncContext;